module.exports = __webpack_public_path__ + "img/exam_jan_2025_2mc4qm8t.82087070.jpg";